__turbopack_context__.v({
  "fullScreenSpinner": "FullScreenSpinner-module__aDlwCW__fullScreenSpinner",
});
